import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  styles: {
    global: {
      p: {
        color: "white",
      },
    },
  },
});

export default theme;
